<template>
  <div class="attachmentList addCommon" style="height: 100%">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{ titleType }}</span>
    </div>
    <div class="content">
      <div class="operationBtn">
        <el-button @click="delBlueprint()" :disabled="delDisabled">{{$t('LanguageLib.DELETE')}}</el-button>
        <el-button type="primary" @click="upLoadAttachment">{{$t('LanguageLib.UPLOAD_FLOOR_PLAN')}}</el-button>
      </div>
      <div class="tableWarp">
        <div class="tableParent">
          <el-table
            empty-text=" "
            :data="tableDataUpload"
            stripe
            @selection-change="selectionChange"
            @sort-change='sortChangeUpload'
            style="width: auto;"
            v-loading="loading"
            :default-sort="defaultSort"
            ref="table"
            height="100%">
            <el-table-column
              type="selection"
              width="45">
            </el-table-column>
            <el-table-column
              prop="sortNo"
              :label="$t('LanguageLib.SERIAL_NUMBER')"
              sortable="custom"
              min-width="60">
              <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start" >
                  <span slot="content" type="sortNo">{{scope.row.sortNo}}</span>
                  <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="sortNo">{{scope.row.sortNo}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="fileName"
              :label="$t('LanguageLib.FLOOR_PLAN_NAME')"
              sortable="custom"
              min-width="150">
              <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <span slot="content" type="fileName">{{scope.row.fileName}}</span>
                  <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="fileName">{{scope.row.fileName}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="AddDate"
              :label="$t('LanguageLib.UPLOAD_TIME')"
              sortable="custom"
              min-width="200">
              <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start">
                <span slot="content" type="addDate">{{$commonfun.formatDate(scope.row.addDate, '1')}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="addDate">{{$commonfun.formatDate(scope.row.addDate, '1')}}</span>
              </el-tooltip>
            </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              :label="$t('LanguageLib.Operation')"
              min-width="50">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="handle(scope.row.fileDirPathFull)"
                  type="text"
                  :title="$t('LanguageLib.LOOK_FLOOR_PLAN')"
                  style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;"
                  size="small">
                  <i class="el-icon-view"></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @size-change="handleSizeChangeUpload"
          @current-change="handleCurrentChangeUpload"
          :current-page="currentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotalUpload">
        </el-pagination>
      </div>
      <el-dialog :title="$t('LanguageLib.UPLOAD_FLOOR_PLAN')" :visible.sync="dialogAttachment" class="upLoadAttachmentDialog dialogAdd" :before-close="closeDialog" :close-on-click-modal="false">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item :label="$t('LanguageLib.SERIAL_NUMBER')">
            <el-input oninput="this.value=this.value.replace(/[^\d]/g,'');" autocomplete="off" :placeholder="$t('LanguageLib.PleaseEnter')" v-model.number="ruleForm.sortNo" maxlength="5"></el-input>
          </el-form-item>
          <el-form-item :label="$t('LanguageLib.FLOOR_PLAN_NAME')" prop="fileName">
            <el-input autocomplete="off" :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.fileName" maxlength="50"></el-input>
          </el-form-item>
          <div style="position: relative;" class="uploadParent">
            <el-upload
              class="upload"
              name="files"
              :data="formData"
              :action="uploadApi"
              :headers="headers()"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :before-upload="beforeUpload"
              :on-error="onError"
              :on-success="onSuccess"
              multiple
              accept=".png, .jpg"
              :file-list="fileList">
              <el-button size="small" type="primary">{{$t('LanguageLib.CLICK_UPLOAD')}}</el-button>
              <div slot="tip" class="el-upload__tip">{{$t('LanguageLib.ONLY_UPLOAD_JPG_OR_PNG_FILE')}}</div>
            </el-upload>
            <el-button size="small" type="primary" style="position: absolute;top: 0;cursor: not-allowed;display: none;background: #f5f7fa;color: #c0c4cc;border: 1px solid #d8dce6;" :style="{display : this.fileShow ? 'none' : 'block'}">{{$t('LanguageLib.CLICK_UPLOAD')}}</el-button>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitBlueprint('ruleForm')" :loading="loadingSave">{{$t('LanguageLib.DETERMINE')}}</el-button>
        </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import storeinformationApi from '../../api/storeinformation'
import baseUrl from '@/utils/base'
export default {
  name: 'AddStore',
  props: ['currentPage', 'pageSize', 'parentId', 'searchText', 'sort', 'sortOrder', 'checkedStoreTypeData', 'checkedModeOperationData', 'checkedBrandData', 'orgName', 'type', 'sortNumber', 'orgTypeid', 'remark'],
  data () {
    var checkSortNo = (rule, value, callback) => {
      if (!value && value !== 0) {
        return callback(new Error(this.$t('LanguageLib.SERIAL_NUMBER') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        callback()
      }
    }
    var checkfileName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.FLOOR_PLAN_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.FLOOR_PLAN_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    return {
      uploadApi: baseUrl.uploadApi, // 上传地址
      loading: true, // loading状态
      titleType: this.$t('LanguageLib.STORE_FLOOR_PLANS'),
      delDisabled: true, // 删除按钮默认禁用
      selectDomainData: [], // 选中的组织数据
      dialogAttachment: false, // 是否显示上传平面图弹框
      fileShow: true, // 是否显示上传按钮
      fileList: [],
      formData: { path: 'images' },
      tableDataUpload: [], // 列表数据
      pageTotalUpload: 0, // 数据总数
      defaultSort: { prop: 'AddDate', order: 'descending' },
      prevSort: 'descending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: 'AddDate', // 记录前一次的prop值
      getBlueprintlist: (pageIndex, pageSize, sort, sortOrder, StoreId) => {
        this.loading = true
        // 请求列表接口数据
        storeinformationApi.blueprintlist('post', '/document/blueprintlist', { pageIndex, pageSize, sort, sortOrder, StoreId })
          .then(res => {
            this.tableDataUpload = res.data.data
            this.pageTotalUpload = res.data.total
            this.loading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数
      uploadcurrentPage: 1, // 默认显示第1页数据
      uploadpageSize: 20, // 默认每页显示20条数据
      uploadsort: 'AddDate', // 排序字段
      uploadsortOrder: 'desc', // 排序方式逆序：desc正序asc
      StoreId: this.$route.query.storeid, // 店铺id
      ruleForm: {
        sortNo: null,
        fileName: '',
        fileDirPath: '',
        fileExtension: '',
        StoreId: this.$route.query.storeid
      },
      rules: {
        sortNo: [
          { validator: checkSortNo, trigger: 'blur' }
        ],
        fileName: [
          { validator: checkfileName, trigger: 'blur' }
        ]
      },
      loadingSave: false // 保存按钮加loding
    }
  },
  created () {
    this.getBlueprintlist(this.uploadcurrentPage, this.uploadpageSize, this.uploadsort, this.uploadsortOrder, this.StoreId)
  },
  methods: {
    // 返回
    goReturn () {
      this.$router.push('/storeinformation/storemanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&checkDomainId=' + this.$route.query.checkDomainId + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&sortOrder=' + this.$route.query.sortOrder + '&checkedStoreTypeData=' + this.$route.query.checkedStoreTypeData + '&checkedModeOperationData=' + this.$route.query.checkedModeOperationData + '&checkedBrandData=' + this.$route.query.checkedBrandData + '&fromPath=addstore')
    },
    // 列表排序
    sortChangeUpload (column) {
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.uploadsortOrder = 'asc'
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.prevSort = 'descending'
          this.uploadsortOrder = 'desc'
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.table.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.uploadsortOrder = column.column.order === 'descending' ? 'desc' : 'asc'
      }
      this.uploadsort = column.prop
      // 请求列表接口数据
      this.getBlueprintlist(this.uploadcurrentPage, this.uploadpageSize, this.uploadsort, this.uploadsortOrder, this.StoreId)
    },
    // 页数改变
    handleSizeChangeUpload (val) {
      this.uploadpageSize = val
      // 请求列表接口数据
      this.getBlueprintlist(this.uploadcurrentPage, this.uploadpageSize, this.uploadsort, this.uploadsortOrder, this.StoreId)
    },
    // 每页条数改变
    handleCurrentChangeUpload (val) {
      this.uploadcurrentPage = val
      // 请求列表接口数据
      this.getBlueprintlist(this.uploadcurrentPage, this.uploadpageSize, this.uploadsort, this.uploadsortOrder, this.StoreId)
    },
    // 上传附件
    headers () {
      return { token: this.$commonfun.localStorage.getitem('token'), lang: this.$commonfun.localStorage.getitem('lang') }
    },
    upLoadAttachment () {
      this.dialogAttachment = true
      this.ruleForm.sortNo = null
      this.ruleForm.fileName = ''
      this.ruleForm.fileDirPath = ''
      this.ruleForm.fileExtension = ''
      this.fileList = []
      this.fileShow = true
    },
    // 确认移除平面图
    handleRemove (file, fileList) {
      this.fileShow = true
      this.ruleForm.fileDirPath = ''
      this.ruleForm.fileExtension = ''
    },
    handlePreview (file) {
    },
    beforeUpload (file) {
      this.fileShow = false
      const type = file.name.slice(file.name.lastIndexOf('.'), file.name.length)
      this.$commonfun.console.log(type)
      if (type !== '.jpg' && type !== '.png' && type !== '.PNG' && type !== '.JPG') {
        this.fileList = []
        this.fileShow = true
        this.$message.success(this.$t('LanguageLib.ONLY_UPLOAD_JPG_OR_PNG_FILE'))
        return true
      }
      new Promise(function (resolve, reject) {
        const width = 2000
        const height = 2000
        const _URL = window.URL || window.webkitURL
        const img = new Image()
        img.onload = function () {
          const valid = img.width < width && img.height < height
          valid ? resolve() : reject(new Error(''))
        }
        img.src = _URL.createObjectURL(file)
      }).then(() => {
        return file
      }, () => {
        this.fileList = []
        this.fileShow = true
        this.$message.success(this.$t('LanguageLib.PLEASE_UPLOAD_A_2000_2000_PIXEL_IMAGE'))
        return true
      })
    },
    // 上传失败
    onError (file, fileList) {
      this.$message.success(this.$t('LanguageLib.UPLOAD_FAILED'))
      this.fileShow = true
    },
    // 上传成功
    onSuccess (file, fileList) {
      this.ruleForm.fileDirPath = file[0]
      this.ruleForm.fileExtension = file[0].slice(file[0].lastIndexOf('.'), file[0].length)
    },
    // 移除文件
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    // 关闭对话框  清除校验
    closeDialog () {
      this.dialogAttachment = false
      this.$refs.ruleForm.resetFields()
    },
    // 保存平面图
    submitBlueprint (formName) {
      if (typeof (this.ruleForm.sortNo) !== 'number') {
        this.ruleForm.sortNo = null
      }
      if (this.ruleForm.fileDirPath === '') {
        this.$message.success(this.$t('LanguageLib.PLEASE_CHOOSE_TO_UPLOAD_A_FILE'))
        return false
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          storeinformationApi.CreateBlueprint('post', '/document/create', this.ruleForm)
            .then(res => {
              this.$message({
                type: 'success',
                message: this.$t('LanguageLib.ADDED_SUCCESSFULLY1')
              })
              this.dialogAttachment = false
              this.getBlueprintlist(this.uploadcurrentPage, this.uploadpageSize, this.uploadsort, this.uploadsortOrder, this.StoreId)
              this.loadingSave = false
            })
            .catch(err => {
              this.loadingSave = false
              this.$commonfun.console.log(err)
            })
        } else {
          return false
        }
      })
    },
    // 查看平面图
    handle (url) {
      var newwin = window.open()
      newwin.document.write('<img style="position: absolute;left: 50%;top: 0;transform: translate(-50%, 0);" src="' + url + '"/>')
    },
    // 删除店铺数据
    delBlueprint () {
      this.$commonfun.confirm(this.$t('LanguageLib.ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT1'), this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          storeinformationApi.delBlueprint('post', '/document/delete', this.selectDomainData)
            .then(res => {
              this.getBlueprintlist(this.uploadcurrentPage, this.uploadpageSize, this.uploadsort, this.uploadsortOrder, this.StoreId)
              this.$message({
                type: 'success',
                message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
              })
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }).catch(() => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.DeletionCancelled')
          })
        })
    },
    // 组织选择
    selectionChange (selection) {
      this.selectDomainData = []
      for (let i = 0; i < selection.length; i++) {
        this.selectDomainData.push(selection[i].id)
      }
      if (this.selectDomainData.length === 0) {
        this.delDisabled = true
      } else {
        this.delDisabled = false
      }
    }
  }
}
</script>

<style lang="scss">
  .attachmentList {
    .TeInput input {
      border-right: 0px;
      border-radius: 4px 0 0 4px;
    }
    .return {
      padding-left: 25px;
      position: relative;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      line-height: 50px;
      border-bottom: 1px solid #F2F2F2;
      .el-icon-back {
        margin-right: 15px;
        cursor: pointer;
      }
      .border {
        position: absolute;
        height: 37px;
        border-left: 1px solid #f1f1f1;
        display: inline-block;
        top: 5px;
      }
      .title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-left: 15px;
      }
    }
    .content::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    .content::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }
    .content::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: #fff;
    }
    .content {
      background: rgba(255, 255, 255, 1);
      width: 100%;
      height: calc( 100% - 66px);
      overflow-y: auto;
      padding: 0 100px 20px 100px;
      padding-top: 15px;
      box-sizing: border-box;
      .operationBtn{
        width: auto;
        display: inline-block;
        .el-button{
          height: 30px;
          padding: 7px 20px;
        }
      }
      .tableWarp{
        height: calc(100% - 45px);
        border: 1px solid #E1E1E1;
      }
      .tableParent{
        height: calc( 100% - 48px );
      }
      .el-pagination{
        padding: 8px 15px 5px;
        height: 35px;
        background: #fff;
      }
      .el-button--primary{
        background-color:#3BC6B9;
        color:#fff;
        border:none;
        margin-left: 10px;
      }
      .el-button--primary:hover{
        background-color:#3BC6B9;
        color:#fff;
        border:none;
      }
      /*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background-color: #3BC6B9 !important;
        border-color: #3BC6B9 !important;
      }*/
      // 更改表格的滚动条样式
      .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
      .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
          width: 10px;
          height: 10px;
      }
      .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
      .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
        background: #E1E1E1;
      }
      .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
      .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
        border-radius: 5px;
        background: #fff;
      }
      .colorG{
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(59,198,185,1);
        line-height:20px;
      }
      .el-table .descending .sort-caret.descending{
        border-top-color: #3BC6B9;
      }
      .el-table .ascending .sort-caret.ascending{
        border-bottom-color: #3BC6B9;
      }
      .el-pager li.active{
        color: #3BC6B9;
      }
      .el-table__fixed-body-wrapper .el-table__body{
          padding-bottom: 10px;
      }
      .el-table-column--selection{
        text-align: center !important;
      }
      .el-tooltip__popper.is-dark{
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        border: 1px solid #E4E7ED !important;
        background-color: #fff;
        color: #000;
        .popper__arrow{
          border-top-color: #E4E7ED;
        }
        .popper__arrow::after{
          border-top-color: #fff;
        }
      }
      // 上传附件样式
      .upLoadAttachmentDialog {
        .el-dialog{
          width: 420px !important;
        }
        .el-dialog__body{
          padding-top: 0;
        }
        .el-form-item__label{
          float: none;
        }
        .el-select{
          width: 100%;
        }
        .el-button--primary{
          margin-left: 0;
        }
        .dialog-footer{
          .el-button{
            padding: 8px 14px;
          }
        }
        .el-upload-list{
          border: none;
        }
        .el-upload-list__item{
          border: none;
        }
      }
      .el-table__fixed-right{
        height: 100% !important;
      }
    }
     /*修改按钮样式*/
    .el-button--primary {
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      height: 30px;
      padding: 7px 20px;
      margin-bottom: 15px;
    }
    .colorRed {
      color: red;
    }
  }
  .uploadParent{
    .el-button--primary{
      margin-bottom: 0;
    }
    .el-upload__tip{
      margin-top: 10px;
    }
  }
</style>
